import {
  $notificationsTableFilters,
  $notificationsTablePage,
  $notificationsTablePageSize,
  $notificationsTableSearch,
  $notificationsTableSort,
  type NotificationsSortState,
} from '@/entities/notifications'
import { type GetApiNotificationsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const NotificationsListPageGate = createGate()

// Last state

// Filters
export const $notificationsListPageLatestFilters =
  createStore<GetApiNotificationsQueryParams>({})
sample({
  source: $notificationsTableFilters,
  clock: NotificationsListPageGate.close,
  target: $notificationsListPageLatestFilters,
})
// Sort
export const $notificationsListPageLatestSort =
  createStore<NotificationsSortState>({
    field: null,
    order: null,
  })
sample({
  source: $notificationsTableSort,
  clock: NotificationsListPageGate.close,
  target: $notificationsListPageLatestSort,
})
// Page
export const $notificationsListPageLatestPage =
  createStore<number>(DEFAULT_PAGE)
sample({
  source: $notificationsTablePage,
  clock: NotificationsListPageGate.close,
  target: $notificationsListPageLatestPage,
})
// Page size
export const $notificationsListPageLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
sample({
  clock: NotificationsListPageGate.close,
  source: $notificationsTablePageSize,
  target: $notificationsListPageLatestPageSize,
})
// Search
export const $notificationsListPageLatestSearch = createStore<string>('')
sample({
  clock: NotificationsListPageGate.close,
  source: $notificationsTableSearch,
  fn: (search) => search || '',
  target: $notificationsListPageLatestSearch,
})
